import "./FlyoutTile.css";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { KEYCODES } from "util/constants";

// TODO:: GR-7482
class FlyoutTile extends React.Component {

    static propTypes = {
        tileName: PropTypes.string.isRequired,
        tileDescription: PropTypes.string.isRequired,
        imgAlt: PropTypes.string.isRequired,
        imgPath: PropTypes.string.isRequired,
        url: PropTypes.string,
        label: PropTypes.string,
        additionalClass: PropTypes.string
    }

    render() {
        const {
            tileName,
            tileDescription,
            additionalClass,
            imgAlt,
            imgPath,
            url
        } = this.props;

        const onKeyUp = (e) => {
            if (e.keyCode === KEYCODES.ENTER) {
                e.preventDefault();
                window.location = url;
            }
        };

        return (
            <div className={classNames("flyout-tile", "product-container", "overview-container", additionalClass)}
                onClick={() => {window.location = url;}}
                role="button"
                tabIndex={0}
                onKeyUp={onKeyUp}
            >
                <img alt={imgAlt} className="flyout-tile-image" src={imgPath} />
                <h2 className="flyout-tile-header">{tileName}</h2>
                <p className="flyout-tile-desc">{tileDescription}</p>
            </div>
        );
    }
}

export default FlyoutTile;